import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  Flex,
  Text,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  useColorModeValue,
  Td,
} from "@chakra-ui/react";
import axios from "axios";
import { FaPrint, FaSync } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Parent_Result = () => {
  const [examResults, setExamResults] = useState([]);
  const [guardianId, setGuardianId] = useState(null);
  const [organizedResults, setOrganizedResults] = useState({}); // Organized data by category
  const tabBg = useColorModeValue("white", "gray.700");
  const selectedTabBgTeal = useColorModeValue("teal.100", "teal.600");
  const selectedTabColorTeal = "teal.800";
  const selectedTabBgGreen = useColorModeValue("green.100", "green.600");
  const selectedTabColorGreen = "green.800";


  const [academicId, setAcademicId] = useState(
    sessionStorage.getItem("Academic")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAcademicId(sessionStorage.getItem("Academic"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);



  useEffect(() => {
    const storedGuardianId = sessionStorage.getItem("user_id"); // Fetch guardian ID from session storage
    setGuardianId(storedGuardianId);

    if (storedGuardianId) {
      axios
        .post(`${BASE_URL}/guardian/exam_result.php`, {
          pass: storedGuardianId,
        })
        .then((response) => {
          if (response.data.exam_result) {
            const filteredDetails = response.data.exam_result.filter(
              (detail) => detail.academic_year_id === academicId
            );
            setExamResults(filteredDetails);
            organizeResultsByCategory(filteredDetails); // Organize data
          } else {
            console.error(
              "Unexpected response structure for exam results:",
              response.data
            );
          }
        })
        .catch((error) => console.error("Error fetching exam results:", error));
    }
  }, [academicId]);

  const organizeResultsByCategory = (results) => {
    const organized = results.reduce((acc, result) => {
      const category = result.category || "Uncategorized";
      const studentName = result.name || "Unknown";

      if (!acc[category]) {
        acc[category] = {};
      }
      if (!acc[category][studentName]) {
        acc[category][studentName] = [];
      }
      acc[category][studentName].push(result);
      return acc;
    }, {});
    setOrganizedResults(organized);
  };

  const renderStudentTable = (results) => (
    <div style={{ overflowX: "auto" }}>
      <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
        <Thead>
          <Tr>
            <Th>Subject</Th>
            <Th>Exam Date</Th>
            <Th>Internal Mark</Th>
            <Th>Written Mark</Th>
            <Th>Total Mark</Th>
            <Th>Grade</Th>
            <Th>Compliment</Th>
          </Tr>
        </Thead>
        <Tbody>
          {results.map((result, index) => (
            <Tr key={index}>
              <Td>{result.subject || "N/A"}</Td>

              <Td>{result.date_of_exam || "N/A"}</Td>
              <Td>{result.internal_mark || "N/A"}</Td>
              <Td>{result.written_mark || "N/A"}</Td>
              <Td>{result.marks || "N/A"}</Td>
              <Td>{result.grade || "N/A"}</Td>
              <Td>{result.compliment || "N/A"}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  );

  return (
    <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Exam Result</h1>
            {/* <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md"
                backgroundColor="white"
                fontSize="11px"
                onClick={() => window.location.reload()}
              >
                <FaSync color="#515B73" />
              </Button>
              <Button
                className="export-button"
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button>
            </div> */}
          </div>
          <div className="breadcrumb">
            <span>Guardian</span> / <span>Exam</span> / <span>Exam Result</span>
          </div>
        </div>
        <Box p={6}>
          <VStack spacing={4} align="stretch">
            <Tabs
              variant="soft-rounded"
              colorScheme="teal"
              isFitted
              p={2}
              borderRadius="md"
              bg={tabBg}
            >
              <TabList>
                {Object.keys(organizedResults).map((category, index) => (
                  <Tab
                    key={index}
                    _selected={{
                      bg: selectedTabBgTeal,
                      color: selectedTabColorTeal,
                      fontWeight: "bold",
                      borderRadius: "md",
                    }}
                    py={2}
                  >
                    {category}
                  </Tab>
                ))}
              </TabList>

              <TabPanels>
                {Object.entries(organizedResults).map(
                  ([category, students], index) => (
                    <TabPanel key={index} p={1}>
                      <Tabs variant="soft-rounded" colorScheme="green" isFitted>
                        <TabList overflowX="auto">
                          {Object.keys(students).map((studentName, idx) => (
                            <Tab
                              key={idx}
                              _selected={{
                                bg: selectedTabBgGreen,
                                color: selectedTabColorGreen,
                                fontWeight: "bold",
                                borderRadius: "md",
                              }}
                              py={2}
                            >
                              {studentName}
                            </Tab>
                          ))}
                        </TabList>

                        <TabPanels>
                          {Object.values(students).map((results, idx) => (
                            <TabPanel key={idx} p={1}>
                              {renderStudentTable(results)}
                            </TabPanel>
                          ))}
                        </TabPanels>
                      </Tabs>
                    </TabPanel>
                  )
                )}
              </TabPanels>
            </Tabs>
          </VStack>
        </Box>
      </div>
    </Box>
  );
};

export default Parent_Result;
